import { StudentAttendanceDetailDTO, StudentGradesDetailDTO, StudentProgressRowDTO, StudentProgressSummaryDTO } from "../../../../models/StudentProgressDTO";

/* Chips de alerta con nombre propio (R2, 2026-10-22): cada uno corresponde a un código de alerta del backend. */
export type ProgressFilter =
	| "todos"
	| "rotativos"
	| "compuestos"
	| "sinAsistir"
	| "faltoSemana"
	| "porGraduarse"
	| "bajoMinimo"
	| "bloqueSinSiguiente"
	| "horasDeMas"
	| "cubierto";

export const PROGRESS_FILTERS: ProgressFilter[] = ["todos", "rotativos", "compuestos", "sinAsistir", "faltoSemana", "porGraduarse", "bajoMinimo", "bloqueSinSiguiente", "horasDeMas", "cubierto"];

export interface ProgressChip {
	llave: ProgressFilter;
	texto: string;
	cuenta: number;
}

/** Opción de un filtro por id (maestra, curso, periodo). */
export interface IdOption {
	id: number;
	name: string;
}

/** Horario distinto dentro de los cursos/periodos elegidos, ya con el nombre en am/pm. */
export interface ScheduleOption extends IdOption {
	level?: string;
	period?: string;
}

/** Las filas con mentorId null se agrupan bajo este id/nombre. */
export const SIN_MAESTRA_ID = 0;
export const SIN_MAESTRA = "Sin Maestra";

/** Selección múltiple por id; vacío = todos. */
export interface StructuredFilters {
	mentorIds: number[];
	courseIds: number[];
	periodIds: number[];
	scheduleIds: number[];
}

export interface StructuredFilterOptions {
	mentors: IdOption[];
	courses: IdOption[];
	periods: IdOption[];
	schedules: ScheduleOption[];
}

export interface AttendanceModalState {
	row: StudentProgressRowDTO | null;
	loading: boolean;
	detail: StudentAttendanceDetailDTO | null;
	error: string | null;
}

/** Detalle de calificaciones (R2): se pide al abrir el modal. */
export interface GradesModalState {
	row: StudentProgressRowDTO | null;
	loading: boolean;
	detail: StudentGradesDetailDTO | null;
	error: string | null;
}

/** Mensaje sugerido de WhatsApp elegido para una fila: el envío sale por WappChat, no por el servidor. */
export interface WhatsappModalState {
	row: StudentProgressRowDTO | null;
	template: string;
}

export interface StudentProgressViewProps {
	sectionLoaded: boolean;
	campusName: string;
	idleLocked: boolean;

	/** Conteos del encabezado sobre las filas filtradas (sin el chip de alerta). */
	summary: StudentProgressSummaryDTO;
	chips: ProgressChip[];
	filter: ProgressFilter;
	onFilter: (filter: ProgressFilter) => void;

	includeInactive: boolean;
	onToggleInactive: () => void;
	includeInactiveStudents: boolean;
	onToggleInactiveStudents: () => void;

	structured: StructuredFilters;
	structuredOptions: StructuredFilterOptions;
	onMentors: (ids: number[]) => void;
	onCourses: (ids: number[]) => void;
	onPeriods: (ids: number[]) => void;
	onToggleSchedule: (scheduleId: number) => void;
	onClearStructured: () => void;

	search: string;
	onSearch: (value: string) => void;

	rows: StudentProgressRowDTO[];
	totalFiltered: number;
	page: number;
	pageCount: number;
	pageSize: number;
	onPage: (page: number) => void;

	/** Exportar solo superadmin (rol 0). */
	canExport: boolean;
	onExport: () => void;

	grades: GradesModalState;
	onOpenGrades: (row: StudentProgressRowDTO) => void;
	onCloseGrades: () => void;

	/** Ficha de la alumna en ventana (PerfilAlumnoModal), sin salir de la pantalla. */
	profileRow: StudentProgressRowDTO | null;
	onOpenProfile: (row: StudentProgressRowDTO) => void;
	onCloseProfile: () => void;

	attendance: AttendanceModalState;
	onOpenAttendances: (row: StudentProgressRowDTO) => void;
	onCloseAttendances: () => void;

	whatsapp: WhatsappModalState;
	onOpenWhatsapp: (row: StudentProgressRowDTO) => void;
	onCloseWhatsapp: () => void;
	onPickTemplate: (key: string) => void;

	/** WhatsApp a varias (EnvioMasivo): ids de alumna elegidos con las casillas. */
	selected: number[];
	onToggleSelected: (studentId: number) => void;
	onSelectMany: (studentIds: number[], checked: boolean) => void;
	onClearSelected: () => void;
	bulkOpen: boolean;
	onOpenBulk: () => void;
	onCloseBulk: () => void;

	/* FASE 3: pestaña Por reponer. */
	campusId: number;
	currencyCode: string;
	tab: ProgressTab;
	onTab: (tab: ProgressTab) => void;
	/** Sesiones por reponer abiertas en las filas cargadas. */
	recoveryOpen: number;
	onRecoveriesChanged: () => void;
}

export type ProgressTab = "progreso" | "reponer";
